
export const Arrowdown = () => (
  <svg
    width="8"
    height="5"
    viewBox="0 0 8 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 1L4 4L1 1"
      stroke="#475867"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);



export function LinkIcon() {
  return (
    <svg
      width="12"
      height="11"
      viewBox="0 0 12 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.75688 0.899934C6.95625 -0.299001 8.90036 -0.299001 10.0997 0.899934C10.6777 1.47619 11.0025 2.25878 11.0025 3.07493C11.0025 3.89108 10.6777 4.67367 10.0997 5.24993L9.09259 6.25708C9.00096 6.35143 8.87408 6.40322 8.74259 6.39993C8.60911 6.40265 8.48023 6.3511 8.38545 6.25708C8.18934 6.05936 8.18934 5.7405 8.38545 5.54279L9.39259 4.53565C10.201 3.7268 10.201 2.41592 9.39259 1.60708C8.56868 0.835952 7.28793 0.835952 6.46402 1.60708L5.46402 2.62136C5.33642 2.74896 5.15045 2.79879 4.97615 2.75209C4.80186 2.70538 4.66571 2.56924 4.61901 2.39494C4.57231 2.22064 4.62214 2.03467 4.74973 1.90708L5.75688 0.899934ZM7.07831 3.21422L4.22116 6.07136C4.12333 6.1644 4.06795 6.2935 4.06795 6.42851C4.06795 6.56351 4.12333 6.69261 4.22116 6.78565C4.31206 6.88191 4.43877 6.93621 4.57116 6.93565C4.70553 6.93567 4.83425 6.88161 4.92831 6.78565L7.78545 3.92851C7.88328 3.83547 7.93866 3.70637 7.93866 3.57136C7.93866 3.43635 7.88328 3.30726 7.78545 3.21422C7.5886 3.02279 7.27515 3.02279 7.07831 3.21422ZM6.54259 7.38565L5.53545 8.39279C4.71154 9.16392 3.43078 9.16392 2.60688 8.39279C1.79851 7.58395 1.79851 6.27306 2.60688 5.46422L3.61402 4.45708C3.74162 4.32948 3.79145 4.14351 3.74474 3.96921C3.69804 3.79491 3.5619 3.65877 3.3876 3.61207C3.2133 3.56536 3.02733 3.6152 2.89973 3.74279L1.89973 4.75708C1.09896 5.52771 0.776948 6.67081 1.05772 7.74612C1.33849 8.82142 2.17825 9.66118 3.25355 9.94195C4.32886 10.2227 5.47196 9.90071 6.24259 9.09993L7.24974 8.09279C7.44698 7.89555 7.44698 7.57575 7.24974 7.37851C7.05249 7.18126 6.73269 7.18126 6.53545 7.37851L6.54259 7.38565Z"
        fill="#1B1B96"
      />
    </svg>
  );
}

export const Homepage = ({ color }) => (
  <svg
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5273 5.88621L7.21432 1.0561C7.01917 0.877408 6.76416 0.778302 6.49956 0.77832C6.23496 0.778338 5.97996 0.877478 5.78484 1.0562L0.47279 5.88618C0.363348 5.98584 0.275893 6.10724 0.216009 6.2426C0.156125 6.37797 0.125129 6.52433 0.125 6.67236V12.8123C0.124999 12.9518 0.152486 13.09 0.20589 13.2189C0.259293 13.3479 0.337568 13.465 0.436245 13.5637C0.534921 13.6623 0.652066 13.7406 0.78099 13.794C0.909914 13.8474 1.04809 13.8748 1.18763 13.8748L4.37468 13.8743C4.51556 13.8743 4.65067 13.8183 4.75029 13.7187C4.8499 13.6191 4.90587 13.484 4.90586 13.3431V9.09307H8.09336V13.3431C8.09336 13.484 8.14932 13.6191 8.24894 13.7187C8.34855 13.8183 8.48366 13.8743 8.62455 13.8743L11.8124 13.8748H11.8125C11.952 13.8748 12.0902 13.8473 12.2191 13.7939C12.348 13.7405 12.4651 13.6623 12.5638 13.5636C12.6625 13.4649 12.7407 13.3478 12.7941 13.2189C12.8475 13.09 12.875 12.9518 12.875 12.8123V6.67238C12.8749 6.52437 12.8439 6.37801 12.784 6.24265C12.7241 6.10729 12.6367 5.98589 12.5273 5.88621Z"
      fill={color}
    />
  </svg>
);


